import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { GenericPermissionErrorPage } from './GenericPermissionErrorPage.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyGenericPermissionErrorPage = lazy<typeof GenericPermissionErrorPage>(() =>
	import(
		/* webpackChunkName: "async-generic-permission-error-page" */ './GenericPermissionErrorPage.tsx'
	).then((module) => module.GenericPermissionErrorPage),
);

export const GenericPermissionErrorPageAsync = () => (
	<Placeholder name="async-generic-permission-error-page" fallback={null}>
		<LazyGenericPermissionErrorPage />
	</Placeholder>
);
